import { AnalyticsBaseType } from '@/types/analytics';

type GlobalWindow = Window & {
  bingMapsCallback?: () => void;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Microsoft?: typeof Microsoft;
  trustedTypes?: {
    createPolicy: (name: string, rules: { createHTML: (input: string) => string; }) => {
      createHTML: (input: string) => TrustedHTML;
    };
  };
  utag?: {
    data?: Record<string, AnalyticsBaseType>;
    link?: (data: Record<string, AnalyticsBaseType>) => void;
    view?: (data: Record<string, AnalyticsBaseType>) => void;
  };
};

export const globalWindow = (typeof window !== 'undefined' ? window as Window : undefined) as GlobalWindow | undefined;
